import React, { useEffect, useState } from "react";
import { TabHeading } from "../../StyledCss/styledCss";
import { getUserCertificates } from "../../api/services/hroneApi";
import "./index.css";

const Others = () => {
  const [certificatesList, setCertificatesList] = useState({});

  useEffect(() => {
    getCertificates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCertificates = async () => {
    try {
      const response = await getUserCertificates();
      if (response.ok) {
        const data = await response.json();
        const keysWithTrueValues = Object.keys(data[0]).filter(
          (key) => data[0][key] === true
        );
        setCertificatesList(keysWithTrueValues);
      }
    } catch (error) {}
  };

  const certificatesLength = Object.values(certificatesList).length;

  return (
    <div>
      <TabHeading>Certificates Submitted</TabHeading>
      <hr />
      <ol>
        {certificatesLength > 0 ? (
          certificatesList.map((eachItem, index) => {
            if (eachItem === "original_degree") {
              const splitText = eachItem.split("_");
              const formattedText =
                splitText[0].charAt(0).toUpperCase() +
                splitText[0].substring(1) +
                " " +
                splitText[1][0].toUpperCase() +
                splitText[1].substring(1);
              return <li key={index}>{formattedText}</li>;
            }
            return (
              <li key={index}>
                {eachItem === "tenth"
                  ? "10th"
                  : eachItem[0].toUpperCase() + eachItem.substring(1)}
              </li>
            );
          })
        ) : (
          <p>No certificates Submitted</p>
        )}
      </ol>
    </div>
  );
};

export default Others;
